import { maxBy } from "lodash-es"

type Entry = {
  value: number
}

export const getMaxScore = (entries: Entry[] = []) => {
  return maxBy(entries, (entry) => entry.value)?.value ?? 0
}
